import { ArrowLeft, Home, Shield, Clock, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import '@/styles/ProductPage.css';

const Properly = () => {
  return (
    <div className="product-page properly-page">
      {/* Header */}
      <header className="product-header" data-testid="product-header">
        <nav className="product-nav" data-testid="product-nav">
          <Button 
            onClick={() => window.location.href = '/'} 
            variant="ghost" 
            className="back-btn"
            data-testid="back-button"
          >
            <ArrowLeft size={20} /> Back to Home
          </Button>
        </nav>
      </header>

      {/* Hero */}
      <section className="product-hero properly-hero" data-testid="hero-section">
        <div className="hero-badge properly-badge" data-testid="hero-badge">COMING EARLY 2026</div>
        <h1 className="product-hero-title" data-testid="hero-title">Properly</h1>
        <p className="product-hero-tagline" data-testid="hero-tagline">
          Property, Properly Done — The Modern Way
        </p>
        <p className="hero-description" data-testid="hero-description">
          Modern UK property transactions with AI-powered legal checks and guaranteed move dates. 
          Making property buying and selling simple, secure, and stress-free.
        </p>
      </section>

      {/* Features */}
      <section className="product-features" data-testid="features-section">
        <div className="container">
          <h2 className="features-title" data-testid="features-title">What to Expect</h2>
          <div className="features-grid">
            <div className="feature-item" data-testid="feature-ai-legal">
              <div className="feature-icon properly-icon">
                <Shield size={48} />
              </div>
              <h3>AI Legal Checks</h3>
              <p>Intelligent AI reviews all legal documents to identify potential issues before they become problems.</p>
            </div>

            <div className="feature-item" data-testid="feature-locked-dates">
              <div className="feature-icon properly-icon">
                <Clock size={48} />
              </div>
              <h3>Locked Move Dates</h3>
              <p>No more uncertainty. Get a guaranteed move date so you can plan your life with confidence.</p>
            </div>

            <div className="feature-item" data-testid="feature-modern-process">
              <div className="feature-icon properly-icon">
                <Home size={48} />
              </div>
              <h3>Modern Process</h3>
              <p>Streamlined digital experience that makes property transactions faster and more transparent.</p>
            </div>

            <div className="feature-item" data-testid="feature-uk-focused">
              <div className="feature-icon properly-icon">
                <CheckCircle size={48} />
              </div>
              <h3>UK Property Experts</h3>
              <p>Built specifically for the UK property market with deep understanding of local regulations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="benefits-section properly-benefits" data-testid="benefits-section">
        <div className="container">
          <h2 className="benefits-title" data-testid="benefits-title">Why Properly?</h2>
          <div className="benefits-list">
            <div className="benefit-row" data-testid="benefit-certainty">
              <CheckCircle className="check-icon" size={24} />
              <p>Eliminate the stress of uncertain moving dates</p>
            </div>
            <div className="benefit-row" data-testid="benefit-transparency">
              <CheckCircle className="check-icon" size={24} />
              <p>Complete transparency throughout the entire process</p>
            </div>
            <div className="benefit-row" data-testid="benefit-speed">
              <CheckCircle className="check-icon" size={24} />
              <p>Faster transactions with modern digital tools</p>
            </div>
            <div className="benefit-row" data-testid="benefit-security">
              <CheckCircle className="check-icon" size={24} />
              <p>AI-powered security checks for peace of mind</p>
            </div>
            <div className="benefit-row" data-testid="benefit-support">
              <CheckCircle className="check-icon" size={24} />
              <p>Expert support from experienced property professionals</p>
            </div>
          </div>
        </div>
      </section>

      {/* Coming Soon */}
      <section className="coming-soon-section" data-testid="coming-soon-section">
        <div className="container">
          <div className="coming-soon-content">
            <h2 className="coming-soon-title" data-testid="coming-soon-title">Launching Early 2026</h2>
            <p className="coming-soon-text" data-testid="coming-soon-text">
              We're working hard to bring you a revolutionary property transaction experience. 
              Properly will transform the way you buy and sell property in the UK.
            </p>
            <p className="coming-soon-interest" data-testid="coming-soon-interest">
              Interested in learning more? <a href="/#contact" className="contact-link" data-testid="contact-link-coming-soon">Get in touch</a> with us.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section properly-cta-section" data-testid="cta-section">
        <h2 className="cta-title" data-testid="cta-title">Stay Updated</h2>
        <p className="cta-description" data-testid="cta-description">
          Want to be the first to know when Properly launches? Contact us to join our waitlist.
        </p>
        <div className="cta-buttons" data-testid="cta-buttons">
          <Button 
            onClick={() => window.location.href = '/#contact'}
            className="cta-button properly-cta-btn"
            data-testid="cta-contact-button"
          >
            Contact Us
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Properly;